import { MatDialog } from '@angular/material/dialog';
import {
  OnboardingComponent,
  OnboardingDialogData,
} from './pages/onboarding/onboarding.component';
import { firstValueFrom } from 'rxjs';

export async function showOnboarding(matDialog: MatDialog) {
  const dialog = matDialog.open<
    OnboardingComponent,
    void,
    OnboardingDialogData
  >(OnboardingComponent, {
    maxHeight: '100vh',
    height: '100vh',
    maxWidth: '100vw',
    width: '100vw',
    panelClass: 'onboarding-dialog',
    disableClose: true,
  });
  await firstValueFrom(dialog.afterClosed());
}
